module.exports = __webpack_public_path__ + "static/img/15.2642077.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/15.png
// module id = C+j9
// module chunks = 0